import { GalleryDto, GalleryFeedbackOptions, TenantDto } from '@picflow/types';
import { productConfig } from '../billing-consts';
import { allFeedbackOptions } from '../consts';
import { Plan } from '../types/plan.type';
import { Product } from '../types/product.type';
import { GalleryAccessLevel } from './access-level';

const feedbackOptionPermissionMapping = {
  favourite: 'asset:favourites',
  color_label: 'asset:color-labels',
  status: 'asset:status',
  comment: 'asset:comments',
  annotation: 'asset:comments',
};

export const getAllowedFeedbackOptions = (
  gallery: GalleryDto,
  plan: Plan,
  accessLevel: GalleryAccessLevel
): GalleryFeedbackOptions[] => {
  if (accessLevel === 'view_only' || accessLevel === 'no_access') return [];
  const scopes = getBillingScopes(gallery, plan);
  const options = allFeedbackOptions.filter(option => {
    return scopes.includes(feedbackOptionPermissionMapping[option]);
  });
  return options;
};

export const getAllowedAndEnabledFeedbackOptions = (
  gallery: GalleryDto,
  plan: Plan,
  accessLevel: GalleryAccessLevel
): GalleryFeedbackOptions[] => {
  if (accessLevel === 'view_only' || accessLevel === 'no_access') return [];
  const options = gallery.enabled_feedback_options;
  return getAllowedFeedbackOptions(gallery, plan, accessLevel).filter(option => {
    return options.includes(option);
  });
};

const getPlanName = (gallery: GalleryDto, plan?: Plan) => {
  if (gallery?.tenant_product_name) return gallery.tenant_product_name;
  if (plan) {
    const galleryTenantId = (gallery.tenant as TenantDto)?.id || (gallery.tenant as string);
    if (plan.tenantId !== galleryTenantId) return;
    return `Picflow ${plan.product.name}`;
  }
};

export const getStorageForProduct = (product: Product) => {
  return productConfig[`Picflow ${product.name}`]?.core_storage;
};

export const getBillingScopes = (gallery: GalleryDto, plan?: Plan) => {
  const planName = getPlanName(gallery, plan);
  if (!planName) {
    return productConfig['Picflow Free']?.scopes;
  }

  const scopes = productConfig[planName]?.scopes;
  if (!scopes) throw 'No permissions for plan: ' + planName;

  return scopes;
};
